import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '加载页',
    component: () => import('@/views/index.vue'),
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('@/views/login/index.vue'),
    meta: { hidden: true },
  },
  {
    path: '/shandong',
    name: '登录_',
    component: () => import('@/views/login/index_sd.vue'),
    meta: { hidden: true },
  },
  {
    path: '/main',
    name: '主界面',
    component: () => import('@/views/main/index.vue'),
    redirect: '/company', //默认打开页面
    children: [
      {
        path: '/company',
        name: '企业中心',
        meta: { id: 2, pid: 2, ctype: 0 },
        component: () => import('@/views/company/index.vue'),
      },
      /* {
					path: "/company_22",
					name: "高新技术企业",
					meta: { id: 22, pid: 2, ctype: 1 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_23",
					name: "瞪羚企业",
					meta: { id: 23, pid: 2, ctype: 2 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_24",
					name: "独角兽企业",
					meta: { id: 24, pid: 2, ctype: 3 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_25",
					name: "民营科技企业",
					meta: { id: 25, pid: 2, ctype: 4 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_26",
					name: "科技型中小企业",
					meta: { id: 26, pid: 2, ctype: 5 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_27",
					name: "专精特新企业",
					meta: { id: 27, pid: 2, ctype: 6 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_28",
					name: "上市企业",
					meta: { id: 28, pid: 2, ctype: 7 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_33",
					name: "一般纳税人",
					meta: { id: 33, pid: 2, ctype: 9 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_34",
					name: "规上企业",
					meta: { id: 34, pid: 2, ctype: 10 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_35",
					name: "知产企业",
					meta: { id: 35, pid: 2, ctype: 11 },
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_29",
					name: "其他企业",
					meta: { id: 29, pid: 2, ctype: 8 },
					component: () => import('@/views/company/index.vue'),
				}, */
      /* {
					path: "/company_30",
					name: "技术转移",
					meta: {id: 9, pid: 2,ctype:9},
					component: () => import('@/views/company/index.vue'),
				},
				{
					path: "/company_31",
					name: "技术合同登记",
					meta: {id: 10, pid: 2,ctype:10},
					component: () => import('@/views/company/index.vue'),
				}, */
      {
        path: '/zhuanxiang',
        name: '专项培育',
        meta: { id: 4, pid: 0 },
        component: () => import('@/views/zhuanxiang/index.vue'),
      },
      {
		path: "/gaoqipeiyu",
		name: "高企培育",
		meta: { id: 652, pid: 0 , ctype: 1},
		component: () => import('@/views/gaoqipeiyu/index.vue'),
      },
      {
		path: "/kexiaopeiyu",
		name: "科小培育",
		meta: { id: 653, pid: 0 , ctype: 2},
		component: () => import('@/views/gaoqipeiyu/index.vue'),
      },
      {
        path: '/project',
        name: '项目导航',
        meta: { id: 6, pid: 0 },
        component: () => import('@/views/project/index.vue'),
      },
      {
        path: '/preaudit',
        name: '预评审',
        meta: { id: 8, pid: 0 },
        component: () => import('@/views/preaudit/index.vue'),
      },
      {
        path: '/map',
        name: '地图展示',
        meta: { id: 3, pid: 0, keepAlive: true },
        component: () => import('@/views/map/index.vue'),
      },
      {
        path: '/mapshow',
        name: '企业地图',
        meta: { id: 3, pid: 0 },
        component: () => import('@/views/map/mapShow.vue'),
      },
      {
        path: '/sms',
        name: '政策宣导',
        meta: { id: 5, pid: 0 },
        component: () => import('@/views/sms/index.vue'),
      },
      {
        path: '/smsadd',
        name: '政策添加',
        meta: { id: 5, pid: 0 },
        component: () => import('@/views/sms/addSms.vue'),
      },
      /* {
			path: "/progress",
			name: "申报可视化",
			meta: {id: 7, pid: 0},
			component: () => import('@/views/progress/index.vue'),
		}, */
      {
        path: '/platform',
        name: '首页',
        meta: { id: 1, pid: 0 },
        component: () => import('@/views/platform/index.vue'),
      },
      {
        path: '/policyxg',
        name: '培训会',
        meta: { id: 11, pid: 0 },
        component: () => import('@/views/policyXg/index.vue'),
      },
      /* {
					path: "/cultivate",
					name: "专项培育",
					meta: {id: 12, pid: 0},
					component: () => import('@/views/cultivate/index.vue'),
				}, */
      {
        path: '/cgzh',
        name: '成果转化',
        meta: { id: 13, pid: 0 },
        component: () => import('@/views/cgzh/index.vue'),
      },
      {
        path: '/diaocy',
        name: '调研组',
        meta: { id: 14, pid: 0 },
        component: () => import('@/views/diaocy/index.vue'),
      },
      {
        path: '/service',
        name: '业务分配',
        meta: { id: 32, pid: 14 },
        component: () => import('@/views/service/index.vue'),
      },
      {
        path: '/attractInvestment',
        name: '招商',
        meta: { id: 41, pid: 0 },
        component: () => import('@/views/attractInvestment/index.vue'),
      },
      {
        path: '/industryAnalysis',
        name: '产业分析',
        meta: { id: 42, pid: 0 },
        component: () => import('@/views/industryAnalysis/index.vue'),
      },
	{
		path: '/userManagement',
		name: '用户管理',
		meta: { id: 654, pid: 0 },
		component: () => import('@/views/userManagement/index.vue'),
	},
      {
        path: '/fintech',
        name: '科技金融',
        meta: { id: 651, pid: 0 },
        component: () => import('@/views/fintech/index.vue'),
      },
      {
        path: '/enterpriseRenewal',
        name: '企业更新',
        meta: { id: 43, pid: 0 },
        component: () => import('@/views/enterpriseRenewal/index.vue'),
      },
      {
        path: '/ipanalyse',
        name: '知产分析',
        meta: { id: 600, pid: 0 },
        component: () => import('@/views/ipanalyse/index.vue'),
      },
      {
        path: '/comparison',
        name: '周期对比',
        meta: { id: 650, pid: 0 },
        component: () => import('@/views/comparison/index.vue'),
      },
      {
        path: '/jbxqzyswq',
        name: '首页-南京江北新区中央商务区',
        meta: { id: 300, pid: 0 },
        component: () => import('@/views/platform/jbxqzyswq.vue'),
      },
      {
        path: '/jngxq',
        name: '首页-南京江宁高新区',
        meta: { id: 301, pid: 0 },
        component: () => import('@/views/platform/jngxq.vue'),
      },
      {
        path: '/cznqq',
        name: '首页-滁州南谯区',
        meta: { id: 302, pid: 0 },
        component: () => import('@/views/platform/cznqq.vue'),
      },
      {
        path: '/ycsyx',
        name: '首页-盐城射阳县',
        meta: { id: 303, pid: 0 },
        component: () => import('@/views/platform/ycsyx.vue'),
      },
      {
        path: '/xsqcxjd',
        name: '首页-杭州萧山区城厢街道',
        meta: { id: 304, pid: 0 },
        component: () => import('@/views/platform/xsqcxjd.vue'),
      },
      {
        path: '/talent',
        name: '人才中心',
        meta: { id: 510, pid: 0 },
        component: () => import('@/views/talent/index.vue'),
      },
      {
        path: '/ycthq',
        name: '首页-盐城亭湖区',
        meta: { id: 511, pid: 0 },
        component: () => import('@/views/platform/ycthq.vue'),
      },
      {
        path: '/ycjhx',
        name: '首页-盐城建湖县',
        meta: { id: 512, pid: 0 },
        component: () => import('@/views/platform/ycjhx.vue'),
      },
      {
        path: '/hahzq',
        name: '首页-淮安洪泽区',
        meta: { id: 513, pid: 0 },
        component: () => import('@/views/platform/hahzq.vue'),
      },
      {
        path: '/hajhx',
        name: '首页-淮安金湖县',
        meta: { id: 514, pid: 0 },
        component: () => import('@/views/platform/hajhx.vue'),
      },
      {
        path: '/njqxxzq',
        name: '首页-南京栖霞行政区',
        meta: { id: 515, pid: 0 },
        component: () => import('@/views/platform/njqxxzq.vue'),
      },
      {
        path: '/njlskfq',
        name: '首页-南京溧水开发区',
        meta: { id: 516, pid: 0 },
        component: () => import('@/views/platform/njlskfq.vue'),
      },
      {
        path: '/njlsyyjd',
        name: '首页-南京溧水永阳街道',
        meta: { id: 517, pid: 0 },
        component: () => import('@/views/platform/njlsyyjd.vue'),
      },
      {
        path: '/njjbxqyyg',
        name: '首页-南京江北新区医药谷',
        meta: { id: 518, pid: 0 },
        component: () => import('@/views/platform/njjbxqyyg.vue'),
      },
      {
        path: '/wxhsqyqjd',
        name: '首页-无锡惠山区堰桥街道',
        meta: { id: 519, pid: 0 },
        component: () => import('@/views/platform/wxhsqyqjd.vue'),
      },
      {
        path: '/njbxgxq',
        name: '首页-南京白下高新区',
        meta: { id: 520, pid: 0 },
        component: () => import('@/views/platform/njbxgxq.vue'),
      },
      {
        path: '/njpkgxq',
        name: '首页-南京浦口高新区',
        meta: { id: 521, pid: 0 },
        component: () => import('@/views/platform/njpkgxq.vue'),
      },
      {
        path: '/szlcy',
        name: '首页-苏州留创园',
        meta: { id: 522, pid: 0 },
        component: () => import('@/views/platform/szlcy.vue'),
      },
      {
        path: '/ykgjkq',
        name: '首页-南通如东县洋口港经济开发区',
        meta: { id: 523, pid: 0 },
        component: () => import('@/views/platform/ykgjkq.vue'),
      },
      {
        path: '/ksjkq',
        name: '首页-昆山经开区',
        meta: { id: 524, pid: 0 },
        component: () => import('@/views/platform/ksjkq.vue'),
      },
      {
        path: '/wyjkq',
        name: '首页-维扬经开区',
        meta: { id: 525, pid: 0 },
        component: () => import('@/views/platform/wyjkq.vue'),
      },
	{
		path: "/hfjkqjxsq",
		name: "首页-合肥经开区锦绣社区",
		meta: { id: 527, pid: 0 },
		component: () => import('@/views/platform/hfjkqjxsq.vue'),
		},
	{
		path: "/ycydq",
		name: "首页-盐城盐都区",
		meta: { id: 528, pid: 0 },
		component: () => import('@/views/platform/ycydq.vue'),
	},
	{
		path: "/jxsr",
		name: "首页-上饶市",
		meta: { id: 655, pid: 0 },
		component: () => import('@/views/platform/jxsr.vue'),
	},
	{
		path: "/technology",
		name: "技术交易",
		meta: { id: 656, pid: 0 },
		component: () => import('@/views/technology/index.vue'),
	},
	{
		path: "/sdqd",
		name: "首页-青岛市",
		meta: { id: 657, pid: 0 },
		component: () => import('@/views/platform/sdqd.vue'),
	},
    ],
  },
  {
    path: '/screen',
    name: '大屏-通用',
    meta: { id: 15, pid: 0 },
    component: () => import('@/views/screen/index.vue'),
  },
  {
    path: '/screen_jbxqzyswq',
    name: '大屏-江北新区中央商务区',
    meta: { id: 502, pid: 0 },
    component: () => import('@/views/screen/index_jbxqzyswq.vue'),
  },
  {
    path: '/screen_zyswqOne',
    name: '大屏-江北新区中央商务区一页展示',
    meta: { id: 15, pid: 0 },
    component: () => import('@/views/screen/index_zyswqOne.vue'),
  },
  {
    path: '/screen_zyswqLeft',
    name: '大屏-江北新区中央商务区左侧',
    meta: { id: 15, pid: 0 },
    component: () => import('@/views/screen/index_zyswqLeft.vue'),
  },
  {
    path: '/screen_zyswqRight',
    name: '大屏-江北新区中央商务区右侧',
    meta: { id: 15, pid: 0 },
    component: () => import('@/views/screen/index_zyswqRight.vue'),
  },
  {
    path: '/screen_ycsyx',
    name: '大屏-盐城射阳县',
    meta: { id: 503, pid: 0 },
    component: () => import('@/views/screen/index_ycsyx.vue'),
  },
  {
    path: '/screen_ycsyx2',
    name: '大屏-盐城射阳县2',
    meta: { id: 504, pid: 0 },
    component: () => import('@/views/screen/index_ycsyx2.vue'),
  },
  {
    path: '/screen_ycsyx3',
    name: '大屏-盐城射阳县3',
    meta: { id: 505, pid: 0 },
    component: () => import('@/views/screen/index_ycsyx3.vue'),
  },
  {
    path: '/screen_njjbxqyyg',
    name: '大屏-南京江北新区医药谷',
    meta: { id: 526, pid: 0 },
    component: () => import('@/views/screen/screen_njjbxqyyg.vue'),
  },
]
export default createRouter({
  history: createWebHashHistory(),
  routes,
})
